export const NO_DATA = 'No data'

export const PATIENT_INFO_TITLES = {
  dateOfBirth: 'DOB: ',
  diagnosisDate: 'Diagnosis Date: ',
}
